/* WashYourPets — behaviour for the Pawvia-style sections.
   Countdown, delivery dates, ticker cloning, straight-to-checkout,
   scroll-to-top, and the non-linking logo. */
(function () {
  'use strict';

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Run each initialiser in isolation so one failure cannot take down the rest. */
  function safe(label, fn) {
    try {
      fn();
    } catch (error) {
      console.warn('[wyp] ' + label + ' failed:', error);
    }
  }

  /* Countdown — resets daily at midnight in the visitor's timezone. */
  function initCountdown(el) {
    var hoursEl = el.querySelector('[data-wyp-hr]');
    var minsEl = el.querySelector('[data-wyp-min]');
    var secsEl = el.querySelector('[data-wyp-sec]');
    if (!hoursEl || !minsEl || !secsEl) return;

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function tick() {
      var now = new Date();
      var midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);

      var remaining = Math.max(0, Math.floor((midnight - now) / 1000));
      hoursEl.textContent = pad(Math.floor(remaining / 3600));
      minsEl.textContent = pad(Math.floor((remaining % 3600) / 60));
      secsEl.textContent = pad(remaining % 60);
    }

    tick();
    setInterval(tick, 1000);
  }

  /* Delivery estimates on the Ordered -> Ready -> Delivered timeline. */
  function initDeliveryDates(root) {
    var opts = { month: 'short', day: 'numeric' };

    root.querySelectorAll('[data-wyp-date]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min-days'), 10) || 0;
      var max = parseInt(el.getAttribute('data-max-days'), 10) || 0;

      var start = new Date();
      start.setDate(start.getDate() + min);

      if (max > min) {
        var end = new Date();
        end.setDate(end.getDate() + max);
        el.textContent =
          start.toLocaleDateString(undefined, opts) + ' - ' + end.toLocaleDateString(undefined, opts);
      } else {
        el.textContent = start.toLocaleDateString(undefined, opts);
      }
    });
  }

  /* Add to cart goes straight to checkout.

     The whole form is serialised on purpose: the bundle app injects its own
     quantity and bundle inputs into it, and the buyer's bundle choice must be
     carried through to the cart exactly as selected.

     Registered on document in the capture phase so it runs before Dawn's
     <product-form> handler, which would otherwise open the cart drawer. */
  function initDirectCheckout() {
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

        event.preventDefault();
        event.stopPropagation();

        var button = form.querySelector('.product-form__submit');
        var spinner = form.querySelector('.loading__spinner');

        if (button) button.setAttribute('aria-disabled', 'true');
        if (spinner) spinner.classList.remove('hidden');

        fetch(shopRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (response) {
            if (!response.ok) throw new Error('cart/add.js returned ' + response.status);
            window.location.href = shopRoot() + 'checkout';
          })
          .catch(function (error) {
            console.warn('[wyp] add to cart failed:', error);
            if (button) button.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      },
      true
    );
  }

  /* The store is a single product page, so the logo has nowhere useful to go. */
  function initLogoUnlink(root) {
    root.querySelectorAll('a.header__heading-link').forEach(function (link) {
      link.removeAttribute('href');
      link.style.cursor = 'default';
    });
  }

  function initScrollTop() {
    var btn = document.querySelector('[data-wyp-to-top]');
    if (!btn) return;

    window.addEventListener(
      'scroll',
      function () {
        btn.classList.toggle('is-visible', window.scrollY > 600);
      },
      { passive: true }
    );

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* Ticker — duplicate the track so the marquee loops seamlessly. */
  function initTickers(root) {
    root.querySelectorAll('.wyp-ticker').forEach(function (ticker) {
      if (ticker.dataset.wypCloned === 'true') return;

      var track = ticker.querySelector('.wyp-ticker__track');
      if (!track) return;

      ticker.appendChild(track.cloneNode(true));
      ticker.dataset.wypCloned = 'true';
    });
  }

  function init(root) {
    safe('countdown', function () {
      root.querySelectorAll('[data-wyp-countdown]').forEach(initCountdown);
    });
    safe('delivery dates', function () {
      initDeliveryDates(root);
    });
    safe('tickers', function () {
      initTickers(root);
    });
    safe('logo unlink', function () {
      initLogoUnlink(root);
    });
  }

  function boot() {
    // Checkout redirect first: it is the one behaviour a checkout depends on.
    safe('direct checkout', initDirectCheckout);
    init(document);
    safe('scroll to top', initScrollTop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
